<template>
<div>
  <v-data-table
      :items="measurements.data"
      :disable-initial-sort="true"
      :headers="headers"
      :pagination.sync="pagination"
      :total-items="total"
      :loading="isLoading"
      :rows-per-page-items="[10,25,50,100]"
      :no-data-text="trans('app.search.no_data')"
  >
    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
    <template slot="items" slot-scope="props">
      <tr>

        <td>
          <span v-if="props.item.water_percentage">{{ props.item.water_percentage }}% ({{ (+props.item.weight * +props.item.water_percentage / 100).toFixed(2) }} kg)</span>
        </td>
        <td>
          <span v-if="props.item.fat_percentage">{{ props.item.fat_percentage }}% ({{ (+props.item.weight * +props.item.fat_percentage / 100).toFixed(2) }} kg)</span>
        </td>
        <td>
          <span v-if="props.item.muscle_percentage">{{ props.item.muscle_percentage }}% ({{ (+props.item.weight * +props.item.muscle_percentage / 100).toFixed(2) }} kg)</span>
        </td>
        <td>
          <span v-if="props.item.bones_percentage">{{ props.item.bones_percentage }}% ({{ (+props.item.weight * +props.item.bones_percentage / 100).toFixed(2) }} kg)</span>
        </td>
        <td class="text-xs-center">
          {{ props.item.created_at | format_date() }}
        </td>
        <td class="justify-end layout px-0 pr-4">
          <v-layout align-center justify-end>
          <icon-button
              :permission="hasPermission('patient_measurements_edit')"
              icon="edit"
              color="success"
              cls="mr-0 ml-0"
              :tooltip="{top: true, bottom: false, attach: false}"
              :iconOptions="{small: true}"
              @click="editMeasurement(props.item)"
          >
            {{ 'app.show_and_edit' | trans }}
          </icon-button>
          <icon-button
              :permission="hasPermission('patient_measurements_delete')"
              icon="delete"
              color="red"
              cls="mr-0 ml-0"
              :tooltip="{top: true, bottom: false, attach: false}"
              :iconOptions="{small: true}"
              @click="deleteMeasurement(props.item)"
          >
            {{ 'app.delete' | trans }}
          </icon-button>
          </v-layout>
        </td>
      </tr>
    </template>
  </v-data-table>
</div>
</template>
<script>
import {trans} from "../../app";
import MeasurementService from "../../services/MeasurementService";
import goTo from "vuetify/lib/components/Vuetify/goTo";
import {mapGetters, mapActions} from "vuex";

export default {
  props: {
    patient_id: {
      type: Number,
    }
  },
  data: function () {
    return {
      items: [],
      headers: [
        {
          text: trans('app.measurements.water'), align: 'left', value: 'water_percentage', sortable: false,
        },
        {
          text: trans('app.measurements.fat'), align: 'left', value: 'fat_percentage', sortable: false,
        },
        {
          text: trans('app.measurements.muscle'), align: 'left', value: 'muscle_percentage', sortable: false,
        },
        {
          text: trans('app.measurements.bones'), align: 'left', value: 'bones_percentage', sortable: false,
        },
        {
          text: trans('app.date'), align: 'center', value: 'created_at', sortable: true,
        },
        {
          text: '', align: 'center', sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 50,
        sortBy: 'created_at',
        descending: true,
      },
      total: 0,
      isLoading: true,
      measurementService: null,
    };
  },
  created() {
    this.measurementService = new MeasurementService();
  },
  methods: {
    ...mapActions(['fetchMeasurements']),
    async fetchData() {
      this.isLoading = true;
      const {sortBy, descending, page, rowsPerPage} = this.pagination;

      const query = {
        page: page,
        perPage: rowsPerPage,
        orderBy: sortBy,
        dir: descending ? 'desc' : 'asc',
      };

      await this.triggerFetchMeasurement(query);

      this.isLoading = false;
    },
    async deleteMeasurement(measurement) {
      const confirm = await this.$confirm(trans('app.measurements.confirm_removal'), {
        title: trans('app.measurements.confirm_removal_title')
      });

      if (confirm) {
        goTo(0, {
          duration: 1000
        });
        this.isLoading = true;
        await this.measurementService.deleteMeasurement(this.patient_id, measurement.id);
        this.$toast(trans('app.removed'));
        await this.fetchMeasurements({patientId: this.patient_id});
        this.isLoading = false;
      }
    },
    async triggerFetchMeasurement(query) {
      await this.fetchMeasurements({
        patientId: this.patient_id,
        params: query || this.pagination,
      });
      this.total = this.measurements.total;
      this.pages = this.measurements.last_page;
    },
    editMeasurement(measurement) {
      this.$emit('edit-measurement', Object.assign({}, measurement));
    }
  },
  watch: {
    pagination: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['measurements', 'hasPermission']),
  }
}
</script>